/** W82 Beta-W (entscheide C7): Entwurf der Rückmeldung nur im Speicher der Seite. Text, verkleinertes Bildschirmfoto und die
 *  Kennung überstehen Schließen und Öffnen des Blatts (Abbrechen, Escape, Wischen, Zeichen und Menü teilen ihn), nicht das
 *  Neuladen; nie `localStorage` oder `sessionStorage` (Briefinhalt gehört nicht auf die Platte). Je Konto ein Entwurf.
 *  Die Kennung entsteht beim ersten Öffnen, bleibt bei jeder Wiederholung nach einem Fehler (der Server gibt dann 200 mit
 *  demselben Körper statt einer zweiten Rückmeldung) und ist erst nach dem Erfolg neu. W82 Web-5h-N2 a7 (H1): erst beim Öffnen
 *  des Blatts im Modus „rueckmeldung“ oder beim Senden (`entwurfKennung`), nicht schon beim Einhängen eines Profil-Menüs.
 *  W82 Beta-W2 (Vertrag Beta-S2 Abschnitt 10): `brief` ist der Brief hinter dem Blatt beim ersten Sendeversuch dieser Kennung
 *  (`entwurfBrief`), `undefined` bis dahin; jede Wiederholung schickt denselben Wert, auch aus einem anderen Brief. */
export type Entwurf = {
  nutzer: string | null;
  text: string;
  bild: Blob | null;
  kennung: string | null;
  brief: string | null | undefined;
};

let entwurf: Entwurf | null = null;

function neu(nutzer: string | null): Entwurf {
  return { nutzer, text: "", bild: null, kennung: null, brief: undefined };
}

/** UUID v4; ohne `crypto.randomUUID` (kein sicherer Kontext) aus `getRandomValues`, sonst aus `Math.random` (nur eine Kennung
 *  gegen doppeltes Senden, kein Geheimnis). */
function uuid(): string {
  const c = typeof crypto === "undefined" ? undefined : crypto;
  if (typeof c?.randomUUID === "function") return c.randomUUID();
  const b = new Uint8Array(16);
  if (typeof c?.getRandomValues === "function") c.getRandomValues(b);
  else for (let i = 0; i < b.length; i++) b[i] = Math.floor(Math.random() * 256);
  b[6] = ((b[6] ?? 0) & 0x0f) | 0x40;
  b[8] = ((b[8] ?? 0) & 0x3f) | 0x80;
  const h = [...b].map((x) => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

/** Die Kennung des Entwurfs; beim ersten Aufruf je Entwurf entsteht sie. */
export function entwurfKennung(nutzer: string | null): string {
  const e = entwurfLesen(nutzer);
  if (e.kennung === null) entwurf = { ...e, kennung: uuid() };
  return entwurf?.kennung ?? "";
}

export function entwurfLesen(nutzer: string | null): Entwurf {
  if (!entwurf || entwurf.nutzer !== nutzer) entwurf = neu(nutzer);
  return entwurf;
}

export function entwurfSetzen(
  nutzer: string | null,
  teil: Partial<Omit<Entwurf, "nutzer" | "kennung" | "brief">>,
): void {
  entwurf = { ...entwurfLesen(nutzer), ...teil };
}

/** Der Brief, der mit dieser Kennung geht: beim ersten Aufruf je Kennung der übergebene (`null` außerhalb einer
 *  Dokumentansicht), danach immer derselbe (der Server ändert die Zuordnung einer Kennung nicht mehr). */
export function entwurfBrief(nutzer: string | null, hinter: string | null): string | null {
  const e = entwurfLesen(nutzer);
  if (e.brief !== undefined) return e.brief;
  entwurf = { ...e, brief: hinter };
  return hinter;
}

/** Nach dem Erfolg: leer und mit neuer Kennung. */
export function entwurfGesendet(nutzer: string | null): void {
  entwurf = neu(nutzer);
}

/** Für Tests: alles vergessen. */
export function entwurfVergessen(): void {
  entwurf = null;
}
